var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaSolidWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.9992H4.2625C4.125 10.9992 4.0125 11.1117 4.0125 11.2492L4.00938 12.7492C4.00938 12.8867 4.12188 12.9992 4.25938 12.9992H15.75C15.8875 12.9992 16 12.8867 16 12.7492V11.2492C16 11.1117 15.8875 10.9992 15.75 10.9992ZM15.75 13.9992H4.25313C4.11563 13.9992 4.00313 14.1117 4.00313 14.2492L4 15.7492C4 15.8867 4.1125 15.9992 4.25 15.9992H15.75C15.8875 15.9992 16 15.8867 16 15.7492V14.2492C16 14.1117 15.8875 13.9992 15.75 13.9992ZM15.75 7.99922H4.26875C4.13125 7.99922 4.01875 8.11172 4.01875 8.24922L4.01562 9.74922C4.01562 9.88672 4.12813 9.99922 4.26562 9.99922H15.75C15.8875 9.99922 16 9.88672 16 9.74922V8.24922C16 8.11172 15.8875 7.99922 15.75 7.99922ZM19.0781 3.65547L10.575 0.114846C10.3922 0.0390267 10.1963 0 9.99844 0C9.80057 0 9.60464 0.0390267 9.42188 0.114846L0.921875 3.65547C0.365625 3.88985 0 4.4336 0 5.03985V15.7492C0 15.8867 0.1125 15.9992 0.25 15.9992H2.75C2.8875 15.9992 3 15.8867 3 15.7492V7.99922C3 7.44922 3.45625 6.99922 4.01875 6.99922H15.9812C16.5438 6.99922 17 7.44922 17 7.99922V15.7492C17 15.8867 17.1125 15.9992 17.25 15.9992H19.75C19.8875 15.9992 20 15.8867 20 15.7492V5.03985C20 4.4336 19.6344 3.88985 19.0781 3.65547Z",
    fill: "#0066A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaSolidWarehouse);
export default __webpack_public_path__ + "static/media/fa-solid-warehouse.898215ac.svg";
export { ForwardRef as ReactComponent };